<template>
    <footer class="jyy-footer">
        <div class="footer-inner">

            <!-- 主体：左侧品牌信息 + 右侧导航 -->
            <div class="footer-main">

                <!-- 左侧：logo + 客服专线 + 二维码 -->
                <div class="footer-brand">
                    <img class="footer-logo" src="../assets/icon_url.png" alt="logo"/>
                    <p class="hotline-label">客服专线</p>
                    <p class="hotline-number">15910967510</p>
                    <div class="footer-qrs">
                        <div>
                            <img src="../assets/weixin.png" alt="官方微信"/>
                            <span>{{ $t('foot_7') }}</span>
                        </div>
                        <div>
                            <img src="../assets/QR_URL.png" alt="手机端"/>
                            <span>{{ $t('foot_8') }}</span>
                        </div>
                    </div>
                </div>

                <!-- 右侧：导航链接栏 -->
                <div class="footer-navs">
                    <div class="footer-col">
                        <span class="footer-col-title">{{ $t('foot_1') }}</span>
                        <a @click="$router.push({ path: '/companyInfo', query: { type: 'GSJJ' } })">{{ $t('index_3') }}</a>
                        <a @click="$router.push({ path: '/companyInfo', query: { type: 'RYZZ' } })">{{ $t('index_4') }}</a>
                        <a @click="$router.push({ path: '/companyInfo', query: { type: 'QYWH' } })">{{ $t('index_5') }}</a>
                    </div>
                    <div class="footer-col">
                        <span class="footer-col-title">{{ $t('foot_2') }}</span>
                        <a v-for="productType in productTypeList" :key="productType.id"
                           :href="'#/productList?type=' + productType.id">
                            {{ productType.name }}
                        </a>
                    </div>
                    <div class="footer-col">
                        <span class="footer-col-title">{{ $t('index_8') }}</span>
                        <a @click="$router.push('/item')">{{ $t('index_9') }}</a>
                        <!-- <a @click="$router.push('/sh')">{{ $t('index_10') }}</a> -->
                        <a @click="$router.push('/fileDownloadList')">{{ $t('index_11') }}</a>
                    </div>
                </div>

            </div>

            <!-- 底部：备案号 -->
            <div class="footer-icp">
                <a target="_blank"  href="https://www.amap.com/ssr/search?query=北京市昌平区沙河新飞达科技发展中心F6-3">{{$t('index_28_1')}}</a>
                <span> · </span>
                <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">京ICP备18042055号</a>
            </div>

        </div>
    </footer>
</template>

<script>
import axios from "@/utils/axios";

export default {
    name: 'IndexFooter',
    data() {
        return {
            productTypeList: null,
        }
    },
    mounted() {
        axios.get('/jyy/portal/getProductTypeList')
            .then(res => {
                this.productTypeList = res.data
            })
    },
}
</script>

<style scoped>

.jyy-footer {
    background: linear-gradient(180deg, #052041 0%, #041a33 100%);
    color: #d5e1f2;
    padding: 48px 0 28px;
}

.footer-inner {
    width: min(1200px, calc(100% - 40px));
    margin: 0 auto;
}

/* 主体两栏 */
.footer-main {
    display: grid;
    grid-template-columns: 280px 1fr;
    gap: 60px;
    padding-bottom: 28px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    align-items: start;
}

/* 左侧品牌区 */
.footer-brand {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.footer-logo {
    width: 160px;
    margin-bottom: 20px;
}

.hotline-label {
    margin: 0;
    font-size: 13px;
    color: rgba(213, 225, 242, 0.7);
}

.hotline-number {
    margin: 4px 0 20px;
    font-size: clamp(22px, 2vw, 30px);
    font-weight: 700;
    color: #fff;
    letter-spacing: 0.5px;
    line-height: 1.2;
}

.footer-qrs {
    display: flex;
    gap: 18px;
}

.footer-qrs div {
    text-align: center;
}

.footer-qrs img {
    width: 88px;
    height: 88px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    display: block;
}

.footer-qrs span {
    display: block;
    margin-top: 8px;
    font-size: 12px;
    color: rgba(213, 225, 242, 0.65);
}

/* 右侧导航栏 */
.footer-navs {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 18px;
}

.footer-col {
    display: grid;
    gap: 8px;
    align-content: start;
}

.footer-col-title {
    color: #fff;
    font-weight: 600;
    font-size: 15px;
    margin-bottom: 6px;
}

.footer-col a {
    color: rgba(213, 225, 242, 0.75);
    text-decoration: none;
    font-size: 13px;
    line-height: 1.8;
    cursor: pointer;
    transition: color 0.2s ease;
}

.footer-col a:hover {
    color: #7fc3ff;
}

/* 备案号 */
.footer-icp {
    padding-top: 20px;
    font-size: 12px;
    color: rgba(213, 225, 242, 0.5);
    text-align: center;
}

.footer-icp a {
    color: rgba(213, 225, 242, 0.5);
    text-decoration: none;
    transition: color 0.2s ease;
}

.footer-icp a:hover {
    color: #d5e1f2;
}

@media screen and (max-width: 900px) {
    .footer-main {
        grid-template-columns: 1fr;
        gap: 36px;
    }

    .footer-navs {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media screen and (max-width: 480px) {
    .footer-navs {
        grid-template-columns: 1fr;
    }
}

</style>
